var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_70",
    "data-name": "Group 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.004,
    height: 27.004,
    viewBox: "0 0 27.004 27.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M134.987,346.134h-9.37A1.612,1.612,0,0,1,124,344.515V342.85a6.275,6.275,0,0,1,1.579-4.178l1.3,1.15a4.55,4.55,0,0,0-1.148,3.028V344.4h9.117V342.85a4.557,4.557,0,0,0-1.135-3.03L135,338.673a6.292,6.292,0,0,1,1.575,4.177v1.665A1.6,1.6,0,0,1,134.987,346.134Z",
    transform: "translate(-116.845 -319.13)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M332.142,223.384a3.16,3.16,0,0,0,.364-1.477,3.195,3.195,0,1,0-1.576,2.747,3.094,3.094,0,0,1,1.466,2.636V228.6h-6.107v1.731h6.191a1.673,1.673,0,0,0,1.647-1.682V227.29A4.824,4.824,0,0,0,332.142,223.384Zm-2.833-.02a1.457,1.457,0,1,1,1.465-1.457A1.462,1.462,0,0,1,329.308,223.364Z",
    transform: "translate(-307.296 -206.099)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M4.788,218.719a3.2,3.2,0,0,0-3.2,3.188,3.159,3.159,0,0,0,.371,1.494A4.824,4.824,0,0,0,0,227.29v1.361a1.648,1.648,0,0,0,1.637,1.682H7.852V228.6H1.731V227.29a3.094,3.094,0,0,1,1.452-2.627,3.19,3.19,0,1,0,1.605-5.944Zm0,4.645a1.457,1.457,0,1,1,1.465-1.457,1.462,1.462,0,0,1-1.465,1.457Z",
    transform: "translate(0 -206.099)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M258,9.541V1.992A1.984,1.984,0,0,1,259.971,0h8.15a2,2,0,0,1,2,1.992V6.227a2.014,2.014,0,0,1-2,2.024h-6a.221.221,0,0,0-.149.038l-2.581,1.944A.851.851,0,0,1,258,9.541Zm1.971-7.81a.244.244,0,0,0-.24.261V7.805l1.194-.9a1.957,1.957,0,0,1,1.191-.387h6a.292.292,0,0,0,.265-.293V1.992a.264.264,0,0,0-.265-.261h-8.15Z",
    transform: "translate(-243.113 0)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M314,56h5.655v1.731H314Z",
    transform: "translate(-295.882 -52.769)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M10.731,10.232,8.15,8.289A.221.221,0,0,0,8,8.251H2A2.014,2.014,0,0,1,0,6.227V1.992A2,2,0,0,1,2,0h8.15a1.984,1.984,0,0,1,1.971,1.992V9.541c-.231,1.278-1.233.806-1.386.691ZM2,1.731a.264.264,0,0,0-.265.261V6.227A.292.292,0,0,0,2,6.52H8a1.956,1.956,0,0,1,1.191.387l1.194.9V1.992a.244.244,0,0,0-.24-.261Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M56,56h5.655v1.731H56Z",
    transform: "translate(-52.769 -52.769)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M169.909,220.31a3.864,3.864,0,0,0-.926,7.616V231.2h1.731v-3.244a3.864,3.864,0,0,0-.805-7.644Z",
    transform: "translate(-156.462 -207.598)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.d76987c359f24c1f55827beaa2fc6b21.svg";
export { ForwardRef as ReactComponent };